/**
 * Resolves per-row smart field overrides for order line grid cells.
 */
export const getLineSmartFieldOverrides = (rowData, field) => {
    if (!rowData?._lineSmartFieldOverrides || !field) {
        return undefined;
    }
    return (
        rowData._lineSmartFieldOverrides[field] ??
        rowData._lineSmartFieldOverrides[field?.toLowerCase?.()]
    );
};

/**
 * Merges line smart field props into cell input params (readOnly, mandatory).
 * Smart field mandatory wins over schema when defined, matching EntityCrudManager.
 */
/** Mandatory uses boolean error so the input turns red without a message below. */
export const toCellValidationError = (errorCode) => {
    if (!errorCode) {
        return '';
    }
    if (errorCode === 'mandatory' || errorCode === true) {
        return true;
    }
    return errorCode;
};

export const applyLineSmartFieldOverridesToInputParams = (inputParams, lineOverrides) => {
    if (!lineOverrides) {
        return inputParams;
    }
    const next = { ...inputParams };
    if (lineOverrides.readOnly || lineOverrides.hidden) {
        next.isReadOnly = true;
    }
    if (lineOverrides.mandatory !== undefined) {
        next.isMandatory = lineOverrides.mandatory;
    }
    return next;
};

export const resolveCellIsEnriched = (inputParams, row, field, isReadOnly = false) => {
    if (isReadOnly || inputParams?.isReadOnly || inputParams?.readOnly) return false;
    const flag = inputParams?.isEnriched;
    if (typeof flag === 'function') return Boolean(flag(row, field));
    return Boolean(flag);
};
